(function(w) {
    w.saveToLocalStorage = function (key, value) {
        if (key && ('localStorage' in w) && w['localStorage'] !== null) {
            w.localStorage.setItem(key, value);
        }
    };

    w.getFromLocalStorage = function (key) {
        return ('localStorage' in w) && w['localStorage'] !== null ? w.localStorage.getItem(key) : null;
    };

    w.removeFromLocalStorage = function (key) {
        if (('localStorage' in w) && w['localStorage'] !== null) {
            w.localStorage.removeItem(key);
        }
    };

    w.getAllFromLocalStorage = function () {
        const keys = [];

        for (var i = 0, len = localStorage.length; i < len; ++i) {
            keys.push(localStorage.key(i));
        }

        return keys;
    };

    w.getAllByPrefixFromLocalStorage = function (prefix) {
        const prefixedKeys = [];

        if (!prefix) { return prefixedKeys };

        for (let i = 0, len = localStorage.length; i < len; ++i) {
            const key = localStorage.key(i);

            if (key && key.indexOf(prefix) === 0) {
                prefixedKeys.push(key);
            }
        }

        return prefixedKeys;
    };

    w.removeByPrefixFromLocalStorage = function (prefix) {
        const prefixedKeys = w.getAllByPrefixFromLocalStorage(prefix);

        prefixedKeys.forEach(function (key) {
            w.removeFromLocalStorage(key);
        });
    };

})(window);